// © Microsoft Corporation. All rights reserved.
import { neutralForegroundHint } from "@microsoft/fast-components-styles-msft";
export const ProfilePostsStyles = {
    profilePostsContainer: {
        display: "flex",
        "flex-flow": "row wrap",
        "align-content": "space-between",
        "justify-content": "space-around",
        "align-items": "flex-start",
        "min-height": "580px",

        /* Force new columns */
        "&::before, &::after": {
            content: "''",
            "flex-basis": "100%",
            width: "0",
            order: "2"
        },

        "& .cwt-content-card": {
            margin: "10px",
            width: "30%"
        },

        "& .cwt-fetching-text": {
            margin: "10px",
            color: neutralForegroundHint
        }
    }
};